import axios from 'axios'

import { customInstance } from '@/features/auth/axios-config'
import { deliverableSetListApi } from '@/features/deliverable-set/services'
import {
  RequestBatchUploadConfirm,
  RequestFilters,
  RequestUploadUrls,
  ResponseConfirmUpload,
  ResponseUploadUrls,
  SuccessResponseListResponseDeliverableSet,
} from '@/schema'

const API_ENDPOINT_UPLOAD = '/document/v1/documents/upload'

export const fileUploadApi = {
  requestUploadUrls: async (
    data: RequestUploadUrls
  ): Promise<ResponseUploadUrls> => {
    try {
      return await customInstance<ResponseUploadUrls>({
        method: 'post',
        url: `${API_ENDPOINT_UPLOAD}/request`,
        data,
      })
    } catch (error) {
      throw new Error(
        `Failed to request upload URLs: ${error instanceof Error ? error.message : 'Unknown error'}`
      )
    }
  },

  uploadFileToBlob: async (
    uploadUrl: string,
    file: File,
    onProgress?: (progress: number) => void
  ): Promise<void> => {
    try {
      await axios.put(uploadUrl, file, {
        headers: {
          'Content-Type': file.type,
          'x-ms-blob-type': 'BlockBlob',
        },
        onUploadProgress: (progressEvent) => {
          if (onProgress && progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            onProgress(percentCompleted)
          }
        },
      })
    } catch (error) {
      throw new Error(
        `Failed to upload file to Azure Blob Storage: ${error instanceof Error ? error.message : 'Unknown error'}`
      )
    }
  },

  confirmUpload: async (
    data: RequestBatchUploadConfirm
  ): Promise<ResponseConfirmUpload> => {
    try {
      return await customInstance<ResponseConfirmUpload>({
        method: 'post',
        url: `${API_ENDPOINT_UPLOAD}/confirm`,
        data,
      })
    } catch (error) {
      throw new Error(
        `Failed to confirm upload: ${error instanceof Error ? error.message : 'Unknown error'}`
      )
    }
  },

  getDeliverableSets: async (
    data: Partial<RequestFilters> = {}
  ): Promise<SuccessResponseListResponseDeliverableSet> => {
    return deliverableSetListApi.getDeliverableSetList(data)
  },
}
